"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6747],{

/***/ 66747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ selectable_tags_grid_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./segments/desktop/core-components/selectable-tags-grid/selectable-tags-grid.js + 1 modules
var selectable_tags_grid = __webpack_require__(94222);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/selectable-tags-grid/selectable-tags-grid-component.scss.js


var REBRAND_BACKGROUND_COLOR = "#2e3248";
var REBRAND_HOVER_BACKGROUND_COLOR = "#262940";
var StyledSelectableTagsGridComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1400dum0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;display:flex;flex-direction:column;align-items:center;&.website-alignment-branding{.selectable-tag-wrapper.dark-mode{background-color:", REBRAND_BACKGROUND_COLOR, ";border-radius:4px;.selectable-tag-image-container{background-color:", REBRAND_BACKGROUND_COLOR, ";.selectable-tag-image{path{fill:", REBRAND_BACKGROUND_COLOR, ";}}}}.selectable-tag-wrapper.dark-mode:hover{background-color:", REBRAND_HOVER_BACKGROUND_COLOR, ";.selectable-tag-image-container{background-color:", REBRAND_HOVER_BACKGROUND_COLOR, ";.selectable-tag-image{path{fill:", REBRAND_HOVER_BACKGROUND_COLOR, ";}}}}.selectable-tag-wrapper.dark-mode.selected{background-color:", REBRAND_HOVER_BACKGROUND_COLOR, ";.selectable-tag-image-container{background-color:currentColor;.selectable-tag-image{path{fill:", REBRAND_HOVER_BACKGROUND_COLOR, ";}}}}}");

// EXTERNAL MODULE: ./segments/desktop/grid/layouts/selectable-tags-grid/selectable-tags-grid-default-props.js
var selectable_tags_grid_default_props = __webpack_require__(79792);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/selectable-tags-grid/selectable-tags-grid-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}





var SelectableTagsGridComponent = function(props) {
    var websiteAlignmentBranding = props.websiteAlignmentBranding;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSelectableTagsGridComponent, {
        className: classnames_default()("selectable-tags-grid-component", {
            "website-alignment-branding": websiteAlignmentBranding
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(selectable_tags_grid/* default */.Z, _object_spread({}, props))
    });
};
SelectableTagsGridComponent.defaultProps = selectable_tags_grid_default_props/* default */.Z;
/* harmony default export */ var selectable_tags_grid_component = (SelectableTagsGridComponent);


/***/ }),

/***/ 79792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var segments_desktop_core_components_selectable_tags_grid_default_props__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24263);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}

/* harmony default export */ __webpack_exports__["Z"] = (_object_spread({}, segments_desktop_core_components_selectable_tags_grid_default_props__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z));


/***/ })

}]);